export const getRetestTiming = (retestDate, today = new Date()) => {
    if (retestDate.getTime() <= today.getTime())
        return 'overdue';
    const oneMonthOut = new Date(today);
    oneMonthOut.setUTCMonth(oneMonthOut.getUTCMonth() + 1);
    if (retestDate.getTime() <= oneMonthOut.getTime())
        return 'within-a-month';
    return 'more-than-a-month';
};
//# sourceMappingURL=getRetestTiming.js.map